/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { StatusLedStyles } from './widgets/status-led-styles';

export default function EntityList(props: any) {
  return (
    <>
      {props.items.map((item: any) => (
        <li key={item._id}>
          <StatusLedStyles>
            <props.itemTemplate dispatch={props.dispatch} {...item} {...props} />
          </StatusLedStyles>
        </li>
      ))}
    </>
  );
}
